const TodayText = [
  [
    '흐물흐물 아무것도 하기 싫은 오늘,',
    '하루 정도는 아무것도 안 해도 괜찮아요~ 🦥',
  ],
  ['그동안 미뤄두었던 목표 중 하나를', '콕 찍어 실행에 옮겨보세요! 🎯'],
  ['오늘은 피부 관리가 필요한 날!', '수분 팩 하나 착~ 붙여주세요! ✨'],
  ['잘하지 못해도 괜찮아요.', '무언가를 했다는 게 중요한 거죠~ 👍'],
  ['잠시 밖으로 나와', '굳은 몸을 쭉쭉 펴보는 건 어떨까요? 🤸‍♂️'],
  ['오늘은 레몬처럼', '상큼한 옷을 입어보는 게 어떨까요? 🍋'],
  ['이걸 먹을까.. 저걸 먹을까 고민될 땐 🤔', '...짬짜면!'],
  ['실수투성이인 오늘...', '괜찮아 다음에 잘하지 뭐~ 👀'],
  ['모르겠고... 아무 노래나 일단 틀어~ 🎶'],
  ['새로운 머리 스타일에 도전해 볼까? 👨‍🎤'],
  ['오늘은 사고 싶었던 것 하나 질러~ 🎁'],
  ['지금 생각난 사람에게 연락해보기! 💌'],
  ['좋은 일이 있을 것만 같은 오늘! 🍀'],
  ['몰라 귀찮아~ 오늘은 그냥 놀자~ 🎉'],
  ['앗 오늘은 내가 커피 쏘는 날?! 🥲'],
  ['상쾌한 아침, 좋은 예감이 들어요~'],
  ['밥 먹고 바로 누운 거 아니죠? 🛌'],
  ['술술 잘 풀릴 것 같은 오늘! 🧻'],
  ['잘했어! 역시 나야 우후훗 👑'],
  ['나는 뭐든지 할 수 있다! 🏆'],
  ['아 맞다! 물 마셔야지! 💧'],
  ['하고 싶은 일을 해요~ 🌟'],
  ['자나 깨나 바른 자세! 🐢'],
  ['바다 보러 갈까? 🏖️'],
  ['괜찮아 잘했어! 👍'],
  ['💎 금전운 +100'],
  ['💕 애정운 +100'],
  ['🍀 행운 +100'],
  ['🌸 행복 +100'],
  ['💪 힘 +100'],
];

export default TodayText;
